module.exports = __webpack_public_path__ + "static/media/managebookActive.4d50ec70.svg";